export interface CheckboxConfig {
  id?: string;
  type?: 'checkbox'; 
  label?: string;
  ariaLabel?: string;
  color?: 'primary' | 'success';
  size?: 'sm' | 'md' | 'lg';
  selectAll?: boolean; // whether this checkbox is a "select all" checkbox
  isSelected?: boolean; // whether the checkbox is currently selected
  isDisabled?: boolean; // whether the checkbox is disabled
  isHtmlLabel?: boolean; // render the label as HTML (e.g. to bold part of it)
}

export const DEFAULT_CHECKBOX_CONFIG: CheckboxConfig = {
  id: '',
  type: 'checkbox',
  label: '',
  ariaLabel: '',
  color: 'primary',
  size: 'md',
  selectAll: false,
  isSelected: false,
  isDisabled: false
};